// extracted by mini-css-extract-plugin
export default {"listItem":"BulletedList_listItem__VGihl"};